<template>
  <div data-grm-comp="RoomCBTModal" class="room-cbt-modal-component">
    <div class="room-cbt-modal flex flex-col">
      <div class="room-cbt-header">
        <h6>전자문제집</h6>
        <GrmCloseBtn @click="onClose" />
      </div>
      <div class="mt-6 min-h-0 flex-1 overflow-hidden flex flex-col">
        <div class="flex justify-end gap-x-1">
          <GrmBtn @click="onOpenRoomCBTLog">출제 이력</GrmBtn>
          <GrmBtn @click="onAddCBT">문제집 추가</GrmBtn>
        </div>
        <div class="room-cbt-list-wrapper min-h-0 flex-1 overflow-y-auto">
          <RoomCBTList />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import RoomCBTCreateModal from "@/components/Room/CBT/RoomCBTCreateModal.vue";
import GrmCloseBtn from "@/components/Common/button/GrmCloseBtn.vue";
import RoomCBTList from "@/components/Room/CBT/RoomCBTList.vue";
import GrmBtn from "@/components/Common/button/GrmBtn.vue";
import RoomCBTLog from "@/components/Room/CBT/RoomCBTLog.vue";

export default {
  name: 'RoomCBTModal',
  components: {
    GrmBtn,
    RoomCBTList,
    GrmCloseBtn
  },
  created() {
    this.getCBTList({
      roomId: this.$room.roomId,
      searchText: '',
      page: 1,
      size: 10
    })
  },
  methods: {
    ...mapActions('cbt', [
      'getCBTList'
    ]),

    onClose() {
      this.$modal('RoomCBTModal')
    },
    onAddCBT() {
      this.$modal(RoomCBTCreateModal)
    },
    onOpenRoomCBTLog() {
      this.$modal(RoomCBTLog)
    }
  }
}
</script>

<style lang="scss" scoped>
.room-cbt-modal-component {
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  z-index: 4;
  white-space: pre-line;
}
.room-cbt-modal {
  position: relative;
  width: 960px;
  height: 90vh;
  padding: 30px 30px 50px 30px;
  border-radius: 12px;
  background-color: white;
  box-shadow: 0 10px 30px rgba(0,0,0,0.4);
}
.room-cbt-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  h6 {
    font-size: 18px;
    font-weight: bold;
  }
}
.room-cbt-list-wrapper {
  margin-top: 16px;
}

// Mobile
[grm-device-mobile]{
  .room-cbt-modal-component {
    left: 0;
    .room-cbt-modal {
      width: 100%;
      height: 100%;
      max-height: none;
      border-radius: 0;
      .room-cbt-contents {
        height: calc(100% - 50px);
      }
    }
  }
}
</style>